var _clipPath, _clipPath2, _clipPath3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m439.996 300h-399.996v179.996h399.996z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m439.996 300h-399.996v179.996h399.996z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 50c0-27.6172-22.387-50-50-50h-300c-27.6133 0-50 22.3828-50 50v380c0 27.613 22.3867 50 50 50h239.996l110.004-110z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.13333333 0 0 -.13333333 0 64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90 5c-24.8164 0-45 20.1875-45 45v380c0 24.816 20.1836 45 45 45h237.926l107.074-107.07v-317.93c0-24.8125-20.187-45-45-45z",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.996 480h-239.996c-27.6133 0-50-22.387-50-50v-380c0-27.6172 22.3867-50 50-50h300c27.613 0 50 22.3828 50 50v320zm-4.141-10 104.145-104.141v-315.859c0-22.0625-17.945-40-40-40h-300c-22.0547 0-40 17.9375-40 40v380c0 22.055 17.9453 40 40 40z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90 5c-24.8164 0-45 20.1875-45 45v380c0 24.816 20.1836 45 45 45h237.926l107.074-107.07v-317.93c0-24.8125-20.187-45-45-45z",
    fill: "#f0a063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.996 480h-239.996c-27.6133 0-50-22.387-50-50v-380c0-27.6172 22.3867-50 50-50h300c27.613 0 50 22.3828 50 50v320zm-4.141-10 104.145-104.141v-315.859c0-22.0625-17.945-40-40-40h-300c-22.0547 0-40 17.9375-40 40v380c0 22.055 17.9453 40 40 40z",
    fill: "#db8951"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m344.352 384.973 96.793-96.793v96.793z",
    fill: "#db8951"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m450 370h-70c-27.613 0-50 22.387-50 50v70h120z",
    fill: "#f8cfb1"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m95.9336 417.699h32.4724v-11.426h-20.039v-11.644h20.039v-11.25h-20.039v-11.953h20.039v-11.426h-32.4724z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151.391 407.328v-14.765h4.836c2.078 0 3.855.746 5.339 2.242 1.477 1.492 2.219 3.265 2.219 5.316 0 2.344-.836 4.16-2.508 5.449-1.668 1.289-4.043 1.934-7.117 1.934zm-12.172 10.371h19.73c5.305 0 9.582-1.547 12.832-4.633 3.254-3.093 4.879-7.156 4.879-12.199 0-3.308-.801-6.453-2.398-9.422-1.598-2.976-4.004-5.195-7.227-6.66-3.222-1.465-5.976-2.226-8.262-2.285l-7.207-.176v-22.324h-12.347z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219.109 412.473-7.73-8.485c-4.074 2.403-7.004 3.606-8.789 3.606-1.379 0-2.567-.524-3.563-1.559-.996-1.039-1.492-2.281-1.492-3.715 0-2.843 2.578-5.304 7.735-7.382 3.777-1.614 6.632-3.075 8.57-4.372 1.93-1.308 3.547-3.113 4.851-5.429 1.305-2.313 1.957-4.821 1.957-7.516 0-4.949-1.996-9.258-6-12.918-3.996-3.664-8.718-5.492-14.168-5.492-5.976 0-11.882 2.809-17.71 8.434l8.171 9.539c3.664-3.782 7.09-5.668 10.286-5.668 1.492 0 2.929.664 4.304 1.992 1.379 1.332 2.067 2.726 2.067 4.187 0 3.008-3.18 5.664-9.535 7.961-3.633 1.321-6.211 2.563-7.735 3.719-1.523 1.156-2.808 2.844-3.844 5.059-1.046 2.207-1.562 4.472-1.562 6.789 0 5.125 1.672 9.285 5.012 12.48 3.336 3.192 7.703 4.789 13.093 4.789 6.387 0 11.746-2.008 16.082-6.019",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.996 220c-66.273 0-120-53.73-120-120 0-3.3789.231-6.6992.5-10h20.008c-.328 3.293-.508 6.6211-.508 10 0 55.137 44.859 100 100 100s100-44.863 100-100c0-3.3789-.183-6.707-.508-10h20.004c.274 3.3008.504 6.6211.504 10 0 66.27-53.726 120-120 120",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340 220h-200v10h200z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225 215v30h30v-30z",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260 250h-40v-40h40zm-10-10v-20h-20v20z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115 75v30h30v-30z",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150 110h-40v-40h40zm-10-10v-20h-20v20z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m335 75v30h30v-30z",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e0e0e0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m370 110h-40v-40h40zm-10-10v-20h-20v20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350 210h-30v30h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160 210h-30v30h30z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEps);
export default __webpack_public_path__ + "static/media/eps.909bbcbd5b361373861431ec5b8a5670.svg";
export { ForwardRef as ReactComponent };